<ion-item *ngFor="let option of TRAVEL_PREFERENCE_OPTIONS">
  <ion-checkbox
    [value]="option.value"
    [checked]="isTravelPreferenceSelected(option.value)"
    (ionChange)="onTravelPreferenceChange(option.value)"
  ></ion-checkbox>
  <ion-label>{{ option.label }}</ion-label>
</ion-item>
